<template>
  <li
    class="flex gap-2 p-2 text-fg-base-fg3 cursor-pointer"
    :class="{
      'bg-surf-neut-soft-hov': isHovered
    }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <wui-icon
      data-test="call-session-guest-menu-item-icon"
      :name="isLoading ? 'spinner' : item.icon"
      small
      class="text-fg-base-fg22"
      :class="{
        'text-fg-base-fg3': isHovered,
        'text-warning-shades-900!': item.id === 'remove'
      }"
    />
    <span>{{ item.label }}</span>
  </li>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { ref } from 'vue'

import { CallSessionGuestMenuItem } from '..'

defineProps<{
  item: CallSessionGuestMenuItem,
  isLoading?: boolean
}>()

const isHovered = ref(false)
</script>
